import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  itemError:
    '{itemRefNumber} does not exist. Please check Item Reference Number and try again.',
})
